import { ColDef } from "ag-grid-community";
import {
  AcceptedCellRenderer,
  ActiveCellRenderer,
  AmountCellRenderer,
  CompletedCellRenderer,
  ConfirmedCellRenderer,
  DateCellRenderer,
  DisputedCellRenderer,
  ExpiredCellRenderer,
  MerchantOrderIdCellRenderer,
  ReceivedCellRenderer,
  TradeIdCellRenderer,
} from "./PrimeOrderCellRenderers";

export const createPrimeOrderColumnDefs = (
  countryFilter?: "IN" | "BR",
): ColDef[] => {
  const baseColumns: ColDef[] = [
    {
      headerName: "Date",
      field: "createdAt",
      flex: 0.8,
      minWidth: 80,
      maxWidth: 120,
      headerClass: "ag-header-cell-custom",
      cellClass: "ag-cell-custom",
      filter: "agDateColumnFilter",
      cellRenderer: DateCellRenderer,
    },
    {
      headerName: "Trade ID",
      field: "tradeId",
      flex: 1,
      minWidth: 100,
      maxWidth: 150,
      headerClass: "ag-header-cell-custom header-left",
      cellClass: "ag-cell-custom",
      filter: "agNumberColumnFilter",
      cellRenderer: TradeIdCellRenderer,
      cellStyle: () => ({
        display: "flex",
        justifyContent: "start",
        alignItems: "center",
      }),
    },
    {
      headerName: "Merch Order ID",
      field: "merchantOrderId",
      flex: countryFilter === "BR" ? 2.3 : 1.5,
      minWidth: 140,
      maxWidth: countryFilter === "BR" ? 350 : 250,
      headerClass: "ag-header-cell-custom",
      cellClass: "ag-cell-custom",
      filter: "agTextColumnFilter",
      cellRenderer: MerchantOrderIdCellRenderer,
      wrapText: true,
      autoHeight: true,
      cellStyle: {
        whiteSpace: "normal",
        wordBreak: "break-word",
        lineHeight: "1.2",
      },
    },
  ];

  const remainingColumns: ColDef[] = [
    {
      headerName: "Amount",
      field: "amount",
      flex: 1.6,
      minWidth: 160,
      maxWidth: 220,
      headerClass: "ag-header-cell-custom",
      cellClass: "ag-cell-custom",
      filter: false,
      sortable: false,
      cellRenderer: AmountCellRenderer,
    },
    {
      headerName: "Received",
      field: "received",
      flex: 0.8,
      minWidth: 80,
      maxWidth: 110,
      headerClass: "ag-header-cell-custom",
      cellClass: "ag-cell-custom",
      filter: false,
      sortable: false,
      cellRenderer: ReceivedCellRenderer,
      cellStyle: () => ({
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }),
    },
    {
      headerName: "Accepted",
      field: "accepted",
      flex: 0.8,
      minWidth: 80,
      maxWidth: 110,
      headerClass: "ag-header-cell-custom",
      cellClass: "ag-cell-custom",
      filter: false,
      sortable: false,
      cellRenderer: AcceptedCellRenderer,
      cellStyle: () => ({
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }),
    },
    {
      headerName: "Confirmed",
      field: "confirmed",
      flex: 0.8,
      minWidth: 80,
      maxWidth: 110,
      headerClass: "ag-header-cell-custom",
      cellClass: "ag-cell-custom",
      filter: false,
      sortable: false,
      cellRenderer: ConfirmedCellRenderer,
      cellStyle: () => ({
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }),
    },
    {
      headerName: "Completed",
      field: "completed",
      flex: 0.8,
      minWidth: 80,
      maxWidth: 110,
      headerClass: "ag-header-cell-custom",
      cellClass: "ag-cell-custom",
      filter: false,
      sortable: false,
      cellRenderer: CompletedCellRenderer,
      cellStyle: () => ({
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }),
    },
    ...(countryFilter !== "BR"
      ? [
          {
            headerName: "Disputed",
            field: "disputed",
            flex: 0.8,
            minWidth: 80,
            maxWidth: 110,
            headerClass: "ag-header-cell-custom",
            cellClass: "ag-cell-custom",
            filter: false,
            sortable: false,
            cellRenderer: DisputedCellRenderer,
            cellStyle: () => ({
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }),
          },
        ]
      : []),

    {
      headerName: "Expired",
      field: "expired",
      flex: 0.6,
      minWidth: 70,
      maxWidth: 100,
      headerClass: "ag-header-cell-custom",
      cellClass: "ag-cell-custom",
      filter: false,
      sortable: false,
      cellRenderer: ExpiredCellRenderer,
      cellStyle: () => ({
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }),
    },
    {
      headerName: "Active",
      field: "active",
      flex: 0.6,
      minWidth: 80,
      maxWidth: 120,
      headerClass: "ag-header-cell-custom",
      cellClass: "ag-cell-custom",
      filter: false,
      sortable: false,
      cellRenderer: ActiveCellRenderer,
      cellStyle: () => ({
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }),
    },
  ];

  return [...baseColumns, ...remainingColumns];
};
